<template>
    <div
        class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
        style="background: linear-gradient(251.83deg, #111D60 2.89%, #334295 89.62%);"
    >
        <!--begin::Content-->
        <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            <router-view></router-view>
            <div class="order-2 order-md-1 mt-4">
                <span class="text-white fw-bold me-1">Copyright &copy;</span>
                <a href="https://www.chainedesrotisseurs.com/" target="_blank" class="text-white">La Chaîne des Rôtisseurs</a>
            </div>
        </div>
        <!--end::Content-->
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
    name: "auth",
    components: {},
    setup() {
        const store = useStore();

        onMounted(() => {
            store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
        });

        onUnmounted(() => {
            store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
        });
    },
});
</script>
